import * as Yup from "yup";

export const formSchema = Yup.object().shape({
  file: Yup.mixed().when("isUpdating", {
    is: false,
    then: Yup.array().required("File is required"),
  }),
});
